(window as any).ngDevMode = (window as any).ngDevMode || false;

import('./bootstrap')
	.catch(err => console.error(err));
